import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './main.css' // 引入全局 CSS 文件'
import AlertComponent from '@/components/AlertsBox'
import "element-plus/dist/index.css";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn' // 引入中文语言包
const app = createApp(App)
// 设置 ElementPlus 使用中文
app.use(ElementPlus, {
  locale: zhCn,
})
app.config.globalProperties.$message = (type, message) => {
  const alertContainer = document.createElement('div')
  alertContainer.className = 'alert-container alert-enter'
  document.body.appendChild(alertContainer)

  const alertInstance = createApp(AlertComponent, {
    type,
    message
  })
  alertInstance.mount(alertContainer)

  // 动画结束后移除类
  setTimeout(() => {
    alertContainer.classList.remove('alert-enter')
  }, 300)

  // 定时移除提示框
  setTimeout(() => {
    alertInstance.unmount() // 使用 alertInstance 调用 unmount
    document.body.removeChild(alertContainer)
  }, 3000) // 可以调整显示时长
}
router.beforeEach((to, from, next) => {
  const bd_vid = to.query.bd_vid || localStorage.getItem('bd_vid');

  // 如果 URL 中有 bd_vid，则将其保存到 localStorage 中
  if (bd_vid) {
    localStorage.setItem('bd_vid', bd_vid);
  }

  // 如果目标路由没有 bd_vid，但我们已经存储了 bd_vid，自动添加到 URL 中
  if (!to.query.bd_vid && bd_vid) {
    // 防止重复导航
    if (to.path === from.path && to.query.bd_vid === bd_vid) {
      next();
    } else {
      next({
        path: to.path,
        params: to.params,
        query: {
          ...to.query,
          bd_vid: bd_vid,
        },
      });
    }
  } else {
    next();
  }
});
app.use(store).use(router).mount('#app')